import {
	Component,
	HostBinding,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	SimpleChange,
	ViewEncapsulation,
} from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { head } from "lodash-es";
import { merge, Subscription } from "rxjs";
import { distinctUntilChanged, map, startWith } from "rxjs/operators";

@Component({
	selector: "obg-common-validation-renderer",
	templateUrl: "./common-validation-renderer.component.html",
	styleUrls: ["./common-validation-renderer.component.scss"],
	encapsulation: ViewEncapsulation.None,
})
export class CommonValidationRendererComponent implements OnInit, OnChanges, OnDestroy {
	@Input() input!: UntypedFormControl;
	@Input() translationPrefix: string | undefined;
	@Input() translationArguments: Record<string, any> = {};
	@Input() disabled: boolean | undefined;

	@HostBinding("class.obg-common-validation-renderer") hostCssClass = true;

	errorKey: string | null = null;

	private error$$: Subscription | undefined;

	ngOnChanges(changes: { translationPrefix?: SimpleChange }) {
		if (changes.translationPrefix) {
			const error = this.input.errors ? head(Object.keys(this.input.errors)) : null;
			this.errorKey = error ? `${this.translationPrefix}.${error}` : null;
		}
	}

	ngOnInit() {
		this.error$$ = merge(this.input.valueChanges, this.input.statusChanges)
			.pipe(
				startWith(null),
				map(() => (this.input.errors ? head(Object.keys(this.input.errors)) : null)),
				distinctUntilChanged()
			)
			.subscribe((error: string) => {
				this.errorKey = error ? `${this.translationPrefix}.${error}` : null;
			});
	}

	ngOnDestroy() {
		if (this.error$$) {
			this.error$$.unsubscribe();
		}
	}

	isInvalidInput(): boolean {
		return !this.disabled && !!this.input && !this.input.valid && this.input.touched;
	}
}
